export default {
  Home: 'Home',
  'Filter All': 'All',
  more: 'More',
  viewMore: 'View More',
  viewLess: 'View Less',
}
